<template>
  <div class="content">
    <div class="complains">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <Card>
             <template slot="header">
              <!-- <div class="row"> -->
              <div class="header-section">
                <div class="dropdown-section">
                  <EmployeeDropdown
                  :employees="$store.state.auth.allUsers"
                  :company="$store.state.auth.company"
                  defaultFilter="active"
                  @update="filteredUsers = $event"
                />
                </div>
                <div class="text-right">
                  <button class="add-complains" @click="openAddComplainModal">Add</button>
                </div>
              </div>
              <!-- </div> -->
             </template>

              <div v-if="loading" class="text-center py-3" style=" margin-top: 60px">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <CustomTable v-else :columns="tableColumns" :data="complains">
                <template #assignee="{ item }">
                  <span class="truncate-text" :title="item.assigneeName || '-'">{{ item.assigneeName || '-' }}</span>
                </template>

                <template #email="{ item }">
                  <span class="truncate-text" :title="item.email">{{ item.email || '-' }}</span>
                </template>

                <template #title="{ item }">
                  <span class="truncate-text" :title="item.title">{{ item.title || '-' }}</span>
                </template>

                <template #desc="{ item }">
                  <span class="truncate-text" :title="item.originalDesc"> {{ item.originalDesc || '-' }} </span>
                </template>
                <template #isHighPriority="{ item }">
                  <span :style="{ color: item.isHighPriority ? '#FF4E50' : 'blue',  }">
                    {{ item.isHighPriority ? "High" : "Normal" || '-' }}
                  </span>
                </template>
                <template #isPersonal="{ item }">
                  <span>{{ item.isPersonal ? "Personal" : "General" || '-' }}</span>
                </template>

                <template #dateLastActivity="{ item }">
                  <span>{{ moment(item.dateLastActivity).fromNow() || '-' }}</span>
                </template>

                <template #feedback="{ item }">
                  <div v-if="item.status === 'Resolved'" class="feedback-cell" :title="!item.feedback ? 'No feedback yet' : null">
                    <template v-if="item.feedback">
                    <span class="stars-contianer">
                      <span style="font-size: 1.7em; " class="stars">
                      <span v-for="n in 5" :key="n" :class="{ 'star-filled': n <= item.feedback.rating }">★</span>
                    </span>
                  </span>
                    <span
                      v-if="item.feedback.comment"
                      class="detail-tooltip-wrapper"
                      @mouseover="showDetails(item.id)"
                      @mouseleave="hideDetails(item.id)"
                      style="font-size: 14px; margin-left: 6px; margin-top:12px;"
                    >
                      <i class="fa fa-info-circle text-info pointer info-icon ml-1"></i>
                      <div
                        v-if="visibleDetails[item.id]"
                        class="detail-tooltip-box"
                      >
                        <div class="details-title text-center">
                          Feedback Comment
                        </div>
                        <div class="detail-text text-start">
                          {{ item.feedback.comment }}
                        </div>
                      </div>
                    </span>
                  </template>
                  <span
                    v-else-if="item.email === user.email"
                    class="add-feedback"
                    @click.stop="openFeedbackModal(item)"
                  >
                    Add Feedback
                  </span>

                    <span v-else>N/A</span>
                  </div>
                  <span v-else>N/A</span>
                </template>

                <template #status="{ item }">
                  <button 
                  class="btn" 
                  style="cursor: pointer;"
                  :class="getStatusClass(item.status)"
                  @click="toggleStatus(item)">
                  {{ item.status }}
                  </button>
                </template>
                </CustomTable>

              <ReuseableModal
                :modelValue="dialog"
                @update:modelValue="dialog = $event"
                title="Create Complaint"
                submit-button-text="Add"
                @submit="addComplain"
              >
                <form @submit.prevent>
                  <div style="margin-top:10px">
                    <label for="assignee">Assignee</label>
                    <CustomDropdown
                      id="assignee"
                      :value="selectedAssigneeName"
                      :options="assigneeOptions"
                      placeholder="Select an assignee"
                      @change="handleAssigneeChange"
                    />
                  </div>
                  <div class="form-group">
                    <label for="title">Title</label>
                    <input type="text" id="title" class="form-control" placeholder="Title here..." v-model="title" maxlength="50" required />
                  </div>
                  <div class="form-group row" style="margin-top: 25px">
                    <div class="col-md-6">
                      <label for="priority">Priority</label>
                      <CustomDropdown
                        id="priority"
                        :value="priority"
                        :options="priorityOptions"
                        placeholder="Select a priority"
                        @change="handlePriorityChange"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="issueType">Issue Type</label>
                      <CustomDropdown
                        id="issueType"
                        :value="issueType"
                        :options="issueTypeOptions"
                        placeholder="Select an issue type"
                        @change="handleIssueTypeChange"
                      />
                    </div>
                  </div>
                  <div  style="margin-top: -10px;">
                    <label for="description">Description</label>
                    <textarea id="description" placeholder="Description here..." class="form-control textarea" v-model="description" rows="2" required></textarea>
                  </div>
                </form>
              </ReuseableModal>

              <ReuseableModal
                :modelValue="feedbackDialog"
                @update:modelValue="feedbackDialog = $event"
                title="Add Feedback"
                submit-button-text="Submit"
                @submit="submitFeedback"
                :loading="isSubmitting"
              >
                <div class="form-group mb-3">
                  <label class="form-label fw-bold mb-1 text-start">
                    Rating <span style="color:red; font-size: 15px; margin-left: -5px">*</span>
                  </label>
                  <div class="rating-stars">
                    <span v-for="n in 5" :key="n"
                          class="star"
                          :class="{ active: n <= feedbackRating }"
                          @click="feedbackRating = n">★</span>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="form-label fw-bold mb-1 text-start">Comment</label>
                  <textarea
                    class="form-control"
                    v-model="feedbackComment"
                    rows="3"
                    maxlength="400"
                    placeholder="Your feedback..."
                  ></textarea>
                  <div class="text-end text-muted small mt-1">
                    {{ feedbackComment.length }}/400
                  </div>
                </div>
              </ReuseableModal>

                </Card>
              </div>
            </div>
            </div>
          </div>
        </div>
      </template>

      <script>
      import CustomTable from "src/components/UIComponents/CustomTable.vue";
      import Card from "../UIComponents/Cards/Card.vue";
      import moment from "moment";
      import swal from "sweetalert";
      import EmployeeDropdown from "../UIComponents/EmployeeDropdown.vue"
      import ReuseableModal from "../UIComponents/ReuseableModal.vue";
      import CustomDropdown from "../UIComponents/CustomDropdown.vue";
      import api from '../../assets/config/api';

      export default {
        components: { CustomTable, Card, EmployeeDropdown, ReuseableModal, CustomDropdown },
        
        created() {
          let store = this.$store;
          this.user = store.state.auth.user;
          this.role = store.state.auth.user.role;
          this.labels = store.state.complains.trelloLabels;
          this.complainsListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.complainsListId || null;
          this.resolvedListId = store.state.complains.trelloListIds && store.state.complains.trelloListIds.resolvedListId || null;
          
          this.assignees = store.state.complains.assignees ? store.state.complains.assignees.map(assignee => ({
            ...assignee,
            fullName: assignee.fullName.includes('_')
              ? assignee.fullName.split('_').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ')
              : assignee.fullName
          })) : [];

          this.items = store.state.complains.cardsData.map(item => {
            const [title, email] = item.name.split(' - ');
            return { ...item, title };
          });
          store.commit("loadingStarts");

          // Fetch Trello cards on first visit
          store.dispatch("fetchTrelloCards").finally(() => {
            store.commit("loadingEnds");
          });

          store.watch(store.getters.cardsData, cardsData => {
            this.items = cardsData.map(item => {
              const [title, email] = item.name.split(' - ');
              return { ...item, title, email };
            });
            store.commit("loadingEnds");
          });

          store.watch(
            () => store.state.complains.assignees,
            (newAssignees) => {
              this.assignees = newAssignees ? newAssignees.map(assignee => ({
                ...assignee,
                fullName: assignee.fullName.includes('_')
                  ? assignee.fullName.split('_').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ')
                  : assignee.fullName
              })) : [];
            }
          );
        },
        
        data() {
          return {
            dialog: false,
            title: "",
            description: "",
            assigneeId: null,
            selectedAssigneeName: "",
            user: null,
            role: null,
            labels: null,
            moment: moment,
            complainsListId: null,
            resolvedListId: null,
            items: [],
            filteredUsers:[],
            assignees: [],
            priority: "Normal",
            issueType: "General",
            priorityOptions: ["High", "Normal"],
            issueTypeOptions: ["General", "Personal"],
            visibleDetails: {},
            feedbackDialog: false,
            feedbackRating: 0,
            feedbackComment: "",
            currentFeedbackItem: null,
            isSubmitting: false,
            tableColumns: [
            { label: "Assignee", key: "assigneeName", sticky: "left", sortable: true, width: 140 },
            { label: "Email", key: "email", sticky: "left", sortable: true, width: 100 },
            { label: "Title", key: "title", sortable: true  },
            { label: "Description", key: "desc"  },
            { label: "Priority", key: "isHighPriority", sortable: true  },
            { label: "Issue Type", key: "isPersonal",sortable: true  },
            { label: "Last Activity", key: "dateLastActivity", sortable: true  },
            { label: "Feedback", key: "feedback", width: 140 },
            { label: "Status", key: "status", sticky: "right", width: 150 }
            ]
          };
          },
   computed: {
    loading() {
      return this.$store.state.loading;
    },
    
    assigneeOptions() {
      return this.assignees.map(assignee => assignee.fullName);
    },
    
    complains() {
      let complainsData = (this.$store.state.complains.cardsData || []).map(item => {
      let title = item.name;
      let email = '';
      if (typeof item.name === 'string' && item.name.includes(' - ')) {
        [title, email] = item.name.split(' - ');
      }

        let feedback = null;
        let originalDesc = item.desc;
        if (item.desc && item.desc.includes('Feedback Submitted')) {
          const parts = item.desc.split('Feedback Submitted');
          originalDesc = parts[0].trim();
          const lastFeedbackPart = parts.pop().trim();
          const ratingMatch = lastFeedbackPart.match(/Rating:\s*([⭐]+)\s*\((\d+)\)/);
          const commentMatch = lastFeedbackPart.match(/Comment:\s*"([^"]*)"/);
          
          // Only create feedback if rating exists (allow empty comment)
          if (ratingMatch) {
            feedback = {
              rating: parseInt(ratingMatch[2]),
              comment: commentMatch ? commentMatch[1] : ""
            };
          }
        }

        return { ...item, title, email, feedback, originalDesc };
      });
      let complains = null
      let filteredEmail = this.filteredUsers.map(user => user.email);
      if (filteredEmail.length > 0) {
        complains = complainsData.filter(complain => filteredEmail.includes(complain.email));
        console.log("===complian",complains)
      }
 
      console.log("===complainsData",complainsData)
      return complains || complainsData;
    }
  },
  
  methods: {
    getStatusClass(status) {
      return {
        Resolved: "status-badge resolved",
        Pending: "status-badge pending",
      }[status] || "status-badge";
    },
    async refreshData() {
      this.$store.commit("loadingStarts");
      try {
        await this.$store.dispatch("fetchTrelloCards", { forceRefresh: true });
        swal("Success", "Data refreshed successfully", "success");
      } catch (error) {
        console.error("Error refreshing data:", error);
        swal("Error", "Failed to refresh data", "error");
      } finally {
        this.$store.commit("loadingEnds");
      }
    },
    
    async toggleStatus(item) {
      // Prevent normal admin from resolving their own complaint
      if (this.user.email === item.email && this.role === 'admin' && !this.user.isSuperAdmin) {
        swal("Restricted", "Admins cannot resolve their own complaints.", "warning");
        return;
      }

      try {
        const targetListId = item.status === "Resolved" 
          ? this.complainsListId  
          : this.resolvedListId;  
        
        const response = await this.updateCardStatus(item.id, targetListId);

        if (response.ok) {
          item.status = item.status === "Resolved" ? "Pending" : "Resolved";
          
          this.$store.dispatch("fetchTrelloCards");
          swal("Great", "Status Updated", "success");
        } else {
          throw new Error(response.statusText);
        }
      } catch (error) {
        console.log("Error:", error);
        swal("Oops!", error.message || "Something went wrong", "error");
      }
    },
    
    async updateCardStatus(cardId, newListId) {
      const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
      const token = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;
      return fetch(`https://api.trello.com/1/cards/${cardId}?key=${apiKey}&token=${token}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          idList: newListId,
        })
      });
    },

    openAddComplainModal() {
      this.dialog = true;
    },

    clearItems() {
      this.dialog = false;
      this.title = "";
      this.description = "";
      this.assigneeId = null;
      this.selectedAssigneeName = "";
      this.priority = "Normal";
      this.issueType = "General";
    },

    handleAssigneeChange(value) {
      const selectedAssignee = this.assignees.find(assignee => assignee.fullName === value);
      if (selectedAssignee) {
        this.assigneeId = selectedAssignee.id;
        this.selectedAssigneeName = selectedAssignee.fullName;
      }
    },

    handlePriorityChange(value) {
      this.priority = value;
    },

    handleIssueTypeChange(value) {
      this.issueType = value;
    },

    async addComplain() {
      this.$store.commit("loadingStarts");
      const { title, description, assigneeId, labels, complainsListId } = this;
      const email = this.user.email;
      const isHighPriority = this.priority === "High";
      const isPersonal = this.issueType === "Personal";
      const isGeneral = this.issueType === "General";

      const memberIds = assigneeId ? [assigneeId] : [];
      const labelIds = this.getLabelIds(isHighPriority, isPersonal, isGeneral, labels);

      try {
        this.validateInputs(title, description, isPersonal, isGeneral, complainsListId);
        const response = await this.createTrelloCard(title, email, description, labelIds, memberIds, complainsListId);

        if (response && response.id) {
          await this.$store.dispatch('updateCardsData', { updatedCard: response });
          this.clearItems();
          swal("Great", "Added", "success");
        } else {
          throw new Error("Failed to create card");
        }
      } catch (error) {
        console.log("Error:", error);
        swal("Oops!", error.message || "Something went wrong", "error");
      } finally {
        this.$store.commit("loadingEnds");
      }
    },

    getLabelIds(isHighPriority, isPersonal, isGeneral, labels) {
      const labelIds = [];

      if (isHighPriority) labelIds.push(labels.highPriorityLabelId);
      if (isPersonal) labelIds.push(labels.personalLabelId);
      else if (isGeneral) labelIds.push(labels.generalLabelId);

      return labelIds;
    },

    validateInputs(title, description, isPersonal, isGeneral, complainsListId) {
      if (!title.trim() || !description.trim()) {
        throw new Error("Title and Description are required");
      }
      if (!isPersonal && !isGeneral) {
        throw new Error("Please provide the issue type");
      }
      if (!complainsListId) {
        throw new Error("The provided list name is not present in your trello board");
      }
    },

    async createTrelloCard(title, email, description, labelIds, memberIds, complainsListId) {
      const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
      const token = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;

      const payload = {
        idList: complainsListId,
        name: `${title} - ${email}`,
        desc: description,
        idLabels: labelIds,
        pos: 1,
        idMembers: memberIds
      };
      
      
      const response = await fetch(`https://api.trello.com/1/cards?key=${apiKey}&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok) {
        return data;
      } else {
        throw new Error(data.error || "Something went wrong creating the card");
      }
    },
    
    getModifiedName(name, isAdmin) {
      const parts = name.split(' - ');
      if (isAdmin) {
        return parts.length > 1 ? `${parts[0]} - <span style="color: pink">${parts[1]}</span>` : name;
      } else {
        return parts.length > 1 ? parts.slice(0, -1).join('-').trim() : name;
      }
    },

    showDetails(id) {
      this.$set(this.visibleDetails, id, true);
    },

    hideDetails(id) {
      this.$set(this.visibleDetails, id, false);
    },

    openFeedbackModal(item) {
      this.currentFeedbackItem = item;
      this.feedbackRating = 0;
      this.feedbackComment = "";
      this.feedbackDialog = true;
    },

    async submitFeedback() {
      if (this.feedbackRating === 0) {
        swal("Error", "Please select a rating", "error");
        return;
      }

      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const stars = '⭐'.repeat(this.feedbackRating);
      const feedbackText = 
      `Feedback Submitted

      * Rating: ${stars} (${this.feedbackRating})
      * Comment: "${this.feedbackComment}"
      Submitted by: ${this.user.email}`;

      const newDesc = this.currentFeedbackItem.desc
        ? `${this.currentFeedbackItem.desc}\n\n${feedbackText}`
        : feedbackText;

      const commentText = `Rating: ${stars} (${this.feedbackRating}) — ${this.feedbackComment} (by ${this.user.email})`;

      this.$store.commit("loadingStarts");

      try {
        const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
        const token = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;
        const cardId = this.currentFeedbackItem.id;
        const descResponse = await fetch(`https://api.trello.com/1/cards/${cardId}?key=${apiKey}&token=${token}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ desc: newDesc })
        });

        if (!descResponse.ok) {
          throw new Error("Failed to update card description");
        }
        const commentResponse = await fetch(`https://api.trello.com/1/cards/${cardId}/actions/comments?key=${apiKey}&token=${token}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text: commentText })
        });

        if (!commentResponse.ok) throw new Error("Failed to post feedback comment");

        await this.$store.dispatch("fetchTrelloCards");
        this.feedbackDialog = false;
        swal("Success", "Feedback submitted", "success");
      } catch (err) {
        console.error(err);
        swal("Error", "Failed to submit feedback", "error");
      } finally {
        this.$store.commit("loadingEnds");
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style>
  .title{
    position: relative;
  }
  .header-section{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
     height: 60px;
  }
  .dropdown-section{
      margin-top: -50px
    }
  @media (max-width: 676px) {
    .header-section {
      flex-direction: column;
      align-items: flex-start;
      height: 100px;
    }
    .header-section  {
      width: 100%;
      margin-bottom: 10px;
    }
    .header-section .text-right {
      text-align: left !important;
    }
    .dropdown-section{
      margin-top: 0px
    }
  }

  .feedback-cell {
    min-width: 120px;
  }

  .star-filled {
    color: #ffc107;
  }

.detail-tooltip-box {
  left: 30px !important;
  width: 200px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/complains/AdminComplains.vue